module.exports = __webpack_public_path__ + "static/media/gesture-keys.2e2f4ce0.svg";